/*
  Copyright (C) SohanIT Inc & JobsHorn. All rights reserved.
  This document contains material and information that is confidential and proprietary to SohanIT Inc & JobsHorn.
  Use and reproduction of this document electronically, copying, regenerating, reengineering, printing, decrypted,
  dissembled, decompiled, reverse-engineered or used to create derivative works or in any form are prohibited and
  governed by U.S. Copyright law. To use, written permission should be obtained from SohanIT Inc & JobsHorn.
*/

import { styled } from '@mui/system';
import { Typography, Grid, Button } from '@mui/material';
import colors from '../../vars.module.scss';

/*
  Business Need: This component provides styles for entire layout and headings.

  Program Functionality:
  - Layout container and main content styling 

  Potential Impact if Updated:
  - layout will change for the application

  Developer: Madhan
  Date: 27/01/2025
*/
export const SectionHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: colors?.primaryColor,
  paddingBottom: theme.spacing(1),
  borderBottom: `2px solid ${colors?.primaryColor}`,
  marginBottom: theme.spacing(2),
}));

export const TopSection = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: `calc(${theme.spacing(5.5)} + ${theme.spacing(2)})`,
  backgroundColor: 'white',
  zIndex: 10,
  paddingTop: '1%',
}));

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const MainContent = styled('div')({
  marginTop: '2.5rem',
  flex: 1,
  overflowY: 'auto', // Enable vertical scrolling
  padding: '16px', // Padding for content area
  scrollbarWidth: 'thin', // For Firefox
  scrollbarColor: 'rgba(0, 0, 0, 0.5) transparent', // For Firefox
  '&::-webkit-scrollbar': {
    width: '10px', // Scrollbar width for Chrome, Safari, and Edge
    marginLeft: '20px', // Margin left for scrollbar
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent', // Scrollbar track background
    marginLeft: '20px', // Margin left for scrollbar track
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Scrollbar thumb color
    borderRadius: '10px', // Scrollbar thumb border radius
    border: '3px solid transparent', // Border around thumb for spacing effect
  },
});

export const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start', // Align buttons to the start of the container
  gap: '15px', // Space between buttons
  marginTop: '16px', // Adjust as needed
  '@media (max-width: 959px)': {
    flexDirection: 'column',
  },
}));

export const StyledOutlinedButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${colors?.primaryColor}`,
  color: colors?.primaryColor,
  '&.preview-btn': {
    border: `1px solid ${colors?.secondaryColor}`,
    color: colors?.secondaryColor,
  },
  '&.save-for-later-btn': {
    border: `1px solid ${colors?.primaryColor}`,
    color: colors?.primaryColor,
  },
  '&:disabled': {
    color: 'lightgray',
    border: `1px solid lightgray`,
  },
  '@media (max-width: 600px)': {
    borderRadius: 10,
  },
}));

export const StyledContainedButton = styled(Button)(({ theme }) => ({
  backgroundColor: colors?.primaryColor,
  color: 'white',
  '&:hover': {
    backgroundColor: colors?.primaryDarkColor,
    color: 'white',
  },
  '&:disabled': {
    backgroundColor: 'lightgray',
    color: 'dimgray',
  },
  '@media (max-width: 600px)': {
    borderRadius: 10,
  },
}));
